/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthSocialLink } from '../../auth.options';
import { getDeepFromObject } from '../../helpers';

import { ApiService } from '../../../services/api.service';
import { URLConfig } from '../../../../configs/url-config';

@Component({
  selector: 'nb-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbLoginComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  socialLinks: NbAuthSocialLink[] = [];
  rememberMe = false;

  constructor(
              private _apiService: ApiService,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected cd: ChangeDetectorRef,
              protected router: Router) {

    this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
    this.showMessages = this.getConfigValue('forms.login.showMessages');
    this.strategy = this.getConfigValue('forms.login.strategy');
    this.socialLinks = this.getConfigValue('forms.login.socialLinks');
    this.rememberMe = this.getConfigValue('forms.login.rememberMe');

    this.checkLogin();
  }

  checkLogin() : boolean{
    let token = this._apiService.getValueLocalstorage();
    if(token){
      this.router.navigate(['/pages/dashboard'])
      return true
    }else {
      return false
    }

  }
  login(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this._apiService.postRequest(URLConfig.login, this.user).subscribe((result:any) => {
      console.log(result)
      this._apiService.success('Login Successfully')
      localStorage.setItem('token', result.data.token)
      localStorage.setItem('user', JSON.stringify(result.data.userdata))
      
      this.router.navigate(['/pages/welcome']);
      this.cd.detectChanges();     
    },
    (error)=>{
      this.submitted = false;
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
